module["exports"] = [
  "#{Address.city} #{suffix}"
];
